const getBookStudyCategoryText = category => {
	const bookStudyCategoryDict = {
		deeper_dive: 'Deeper Dive',
		theme: 'Theme',
		knowledge: 'Knowledge'
	};

	return bookStudyCategoryDict[category] || '';
};

module.exports = {
	getBookStudyCategoryText
};
